var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApple24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 18.374c-.864 1.302-1.779 2.572-3.173 2.593-1.393.032-1.84-.83-3.421-.83-1.592 0-2.08.81-3.401.862-1.363.052-2.392-1.386-3.266-2.657-1.778-2.593-3.14-7.37-1.31-10.583.904-1.596 2.527-2.604 4.285-2.635 1.33-.021 2.6.913 3.421.913.812 0 2.35-1.123 3.963-.955.676.031 2.569.273 3.785 2.079-.093.063-2.256 1.343-2.236 4 .032 3.17 2.756 4.231 2.788 4.242-.032.073-.437 1.511-1.436 2.97Zm-5.94-16.8C14.01.705 15.269.043 16.309 0c.136 1.228-.353 2.467-1.081 3.35-.718.892-1.903 1.585-3.068 1.49-.156-1.207.426-2.467 1.092-3.265Z",
    fill: "#000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple24);
export default __webpack_public_path__ + "static/media/apple_24.73355994.svg";
export { ForwardRef as ReactComponent };